import { head } from 'es-toolkit/compat';

import type { SupportedLocale } from '../../../configuration';
import { supportedLocaleMap } from '../../../configuration/lang/lang';

// Get the locale short that will be used to find the right translation file
// biome-ignore lint/style/noNonNullAssertion: TODO: review this suppression
const createLocaleShort = (locale: string) => head(locale.split('-'))!.toLowerCase();
const browserLocale = navigator.language as string;
let enforcedLocale: string;

// adapt for possible language code extensions (http://www.lingoes.net/en/translator/langcode.htm)
const DEFAULT_LOCALE = 'en-GB';

/*
 Languages returned by UserAdmin Service:
 cs-CZ
 da-DK
 de-DE
 nl-NL
 en-US
 es-ES
 fr-FR
 it-IT
 pl-PL
 ro-RO
 */

const getSupportedLanguageKey = (locale: string): SupportedLocale => {
    if (Object.hasOwn(supportedLocaleMap, enforcedLocale)) {
        return enforcedLocale as SupportedLocale;
    }
    if (Object.hasOwn(supportedLocaleMap, locale)) {
        return locale as SupportedLocale;
    }
    if (Object.hasOwn(supportedLocaleMap, browserLocale)) {
        return browserLocale as SupportedLocale;
    }
    return DEFAULT_LOCALE;
};

const setEnforcedLocale = (locale: string) => {
    if (locale) {
        enforcedLocale = getSupportedLanguageKey(locale);
    }
};

const getEnforcedLocale = () => enforcedLocale;

export {
    browserLocale,
    createLocaleShort,
    DEFAULT_LOCALE,
    getEnforcedLocale,
    getSupportedLanguageKey,
    setEnforcedLocale,
};
